import React, {useEffect} from 'react';

type Props = {
    id?: string,
    content: string,
    onRead?: (id: string) => void,
    width: number | string,
    maxHeight?: number | string,
};

export const NotificationContent = ({id, content, onRead, width, maxHeight}: Props) => {

    useEffect(() => {
        if (onRead && id) {
            onRead(id);
        }
    }, [id, onRead]);

    return (
        <div style={{overflowY: 'auto', width, maxHeight}}>
            {/* eslint-disable-next-line react/no-danger */}
            <div className="ql-editor" dangerouslySetInnerHTML={{__html: content}}/>
        </div>
    );
};
